import _get from 'lodash/get';
import { ratesLabels, fallbackInterestRates } from 'axl-config';
const calculateDownPayment = (listedPrice, downPayment, downPaymentPercent) => downPayment ?? (Number((listedPrice * downPaymentPercent).toFixed(2)) || 0);
const buildPaymentCashObject = listedPrice => ({
  cash: {
    offerPrice: listedPrice
  }
});
const buildPaymentFinanceObject = (listedPrice, loanTerm, downPayment, downPaymentPercent) => ({
  finance: {
    offerPrice: listedPrice,
    downPayment: calculateDownPayment(listedPrice, downPayment, downPaymentPercent),
    selectedTerm: Number(loanTerm)
  }
});
const buildPaymentLeaseObject = (listedPrice, leaseTerm, leaseMileageRange, downPayment, downPaymentPercent) => ({
  lease: {
    offerPrice: listedPrice,
    downPayment: calculateDownPayment(listedPrice, downPayment, downPaymentPercent),
    selectedTerm: Number(leaseTerm),
    annualMiles: Number(leaseMileageRange)
  }
});
function buildPaymentObject(payments, listedPrice, cashDealPrice) {
  const {
    creditType,
    loanTerm,
    downPayment,
    downPaymentPercent,
    leaseMileageRange,
    dealType,
    leaseTerm,
    penciling,
    dueAtSigning
  } = payments || {};
  const decodedCreditType = typeof creditType === 'number' ? creditType : ratesLabels[creditType]?.decodedValue;
  const creditScoreHigh = _get(fallbackInterestRates, `${decodedCreditType}.creditScoreHigh`, '');
  const vehicleOfferPrice = penciling?.offerPrice ?? listedPrice;
  const payment = {
    cash: buildPaymentCashObject(cashDealPrice || listedPrice),
    finance: buildPaymentFinanceObject(vehicleOfferPrice, loanTerm, downPayment, downPaymentPercent),
    lease: buildPaymentLeaseObject(listedPrice, leaseTerm, leaseMileageRange, dueAtSigning || downPayment, downPaymentPercent)
  }[dealType] ?? {};
  return {
    ...payment,
    selectedOfferType: dealType || 'finance',
    creditScore: creditScoreHigh
  };
}
export { calculateDownPayment, buildPaymentObject as default };
